export const PERMISSION_LEVELS = {
  READ: 0,
  WRITE: 1,
  OWNER: 2,
} as const

export type PermissionLevel = keyof typeof PERMISSION_LEVELS
export type PermissionLevelValue = typeof PERMISSION_LEVELS[keyof typeof PERMISSION_LEVELS]

export const PERMISSION_LEVELS_AS_OPTIONS = {
  READ: "Read",
  WRITE: "Write",
  OWNER: "Owner",
} as const

export function hasPermission(currentPermission: PermissionLevel, requiredPermission: PermissionLevelValue) {
  return PERMISSION_LEVELS[currentPermission] >= requiredPermission
}
